import Axios from "axios";

import { AuthAction } from "../store/actions";

import { store } from "../store";
import BASE_URL from "./contants";

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  ({ response }) => {
    if (response.status === 401) {
      store?.dispatch(AuthAction.Logout());
    }
    return response;
  }
);

Axios.interceptors.request.use(
  function (config) {
    const token = store.getState().auth.user.token;
    const LSToken = localStorage.getItem("authUser");
    if (token) {
      config.headers = {
        ...config?.headers,
        Authorization: `Bearer ${token}`,
        app: "web",
      };
      return config;
    } else if (LSToken) {
      config.headers = {
        ...config?.headers,
        Authorization: `Bearer ${
          JSON.parse(localStorage.getItem("authUser"))?.token
        }`,
        app: "web",
      };
      return config;
    } else {
      config.headers = {
        ...config?.headers,
        app: "web",
      };
      return config;
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default class ApiCaller {
  static Get = (endPoint = "", headers = {}) => {
    return Axios.get(`${BASE_URL}${endPoint}`, {
      headers,
    })

      .then((res) => res)
      .catch((err) => err.response);
  };

  static Post = (endPoint = "", body = {}, headers = {}) => {
    return Axios.post(`${BASE_URL}${endPoint}`, body, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
  static Put = (endPoint = "", body = {}, headers = {}) => {
    return Axios.put(`${BASE_URL}${endPoint}`, body, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
  static Delete = (endPoint = "", headers = {}) => {
    return Axios.delete(`${BASE_URL}${endPoint}`, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
}
